/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-11 19:58:47
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-08-13 17:43:36
 * @FilePath: \bee-transport-h5-v1.0.3d:\project\beecargo-web\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const isMobilePhone = () => {
  if (typeof navigator === 'undefined') return false

  return /Android.*Mobile|iPhone|iPod|Windows Phone|IEMobile|BlackBerry|BB10|Opera Mini|webOS/i.test(
    navigator.userAgent
  )
}

const routes = [
  {
    // redirect:'/home',
    path: '',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/contactUs/customerService',
    component: () => import('@/views/contactUs/customerService/index.vue')
  },
  {
    path: '/shareOrderDetails',
    component: () => isMobilePhone()
      ? import('@/views/mobileShareOrderDetails/index.vue')
      : import('@/views/shareOrderDetails/index.vue')
  },
  {
    path: '/shareOrderColdData',
    component: () => import('@/views/shareOrderColdData/index.vue')
  },{
    path:'/previewPage',
    component: () => import('@/views/preview-page/index.vue'),
    meta: {
      title: '图片预览'
    }
  }
]

const router = new VueRouter({
  mode:'hash',
  routes
})

export default router
